export default {
  primary: {
    main: 'rgb(115, 64, 170)',
  },
  secondary: {
    main: 'rgba(0, 0, 0, .6)',
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.8)',
    secondary: 'rgba(0, 0, 0, 0.6)',
    disabled: 'rgba(0, 0, 0, 0.4)',
  },
};
